
export const siteSourceMap: Map<string, string> = new Map([['www.bhg.com', '263'], ['www.allrecipes.com', '224'], ['www.eatingwell.com', '257']]);
